import { render } from "./FashionEcommerceGalleryView.vue?vue&type=template&id=3a57b314&scoped=true"
import script from "./FashionEcommerceGalleryView.vue?vue&type=script&lang=js"
export * from "./FashionEcommerceGalleryView.vue?vue&type=script&lang=js"

import "./FashionEcommerceGalleryView.vue?vue&type=style&index=0&id=3a57b314&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a57b314"]])

export default __exports__